<template>
<v-container>
      <v-expansion-panel v-model="panel" expand>

        <v-expansion-panel-content :style="'color:white;background-color:' + theme.primary.base">
          <template v-slot:header>
            <div><v-icon dark>device_hub</v-icon><label class="ml-1">Route</label></div>
          </template>          
            <v-card flat class="slider-card">
              <v-layout>
                <v-flex>
                  <v-checkbox
                    v-model="directFlightChecked"
                    :label="'Direct'" @change="getRouteIndicator()"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                  v-model="connectingFlightChecked"
                    :label="'Connecting'" @change="getRouteIndicator()"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card>
        </v-expansion-panel-content> 

        <v-expansion-panel-content :style="'color:white;background-color:' + theme.primary.base">
          <template v-slot:header>
            <div><v-icon dark>local_atm</v-icon><label class="ml-1">Price</label></div>
          </template>          
            <v-card flat class="slider-card">
                <div><span>Price</span> {{helper.numberFormat.formatPrice(priceRange.value[0]) + "-" + helper.numberFormat.formatPrice(priceRange.value[1])}}</div>
                <v-range-slider
                    v-model="priceRange.value"
                    step="10"
                    :min="LowestPrice"
                    :max="HighestPrice"
                    @change="getPriceRange()"
                ></v-range-slider>
            </v-card>
        </v-expansion-panel-content>     

        <v-expansion-panel-content :style="'color:white;background-color:' + theme.primary.base">
          <template v-slot:header>
            <div><v-icon dark>insert_invitation</v-icon><label class="ml-1">Departure Time</label></div>
          </template>          
            <v-card flat class="slider-card">
                <div>{{filtering.timeSlots[outboundDepartureTimeRange.value[0]-1] + "-" + filtering.timeSlots[outboundDepartureTimeRange.value[1]-1]}}</div>
                <v-range-slider
                    v-model="outboundDepartureTimeRange.value"
                    step="1"
                    min="1"
                    :max="filtering.timeSlots.length"
                    @change="getOutboundDepartureTimeRange()"
                ></v-range-slider>
            </v-card>
            <!-- <v-card flat class="slider-card">
                <div><span>Return</span> {{filtering.timeSlots[returnDepartureTimeRange.value[0]-1] + "-" + filtering.timeSlots[returnDepartureTimeRange.value[1]-1]}}</div>
                <v-range-slider
                    v-model="returnDepartureTimeRange.value"
                    step="1"
                    min="1"
                    :max="filtering.timeSlots.length"
                    @change="getReturnDepartureTimeRange()"
                ></v-range-slider>
            </v-card>             -->
        </v-expansion-panel-content>                           

        <v-expansion-panel-content :style="'color:white;background-color:' + theme.primary.base">
          <template v-slot:header>
            <div><v-icon dark>access_time</v-icon><label class="ml-1">Flight Duration</label></div>
          </template>          
            <v-card flat class="slider-card">
                <div><span>Hours</span> {{flightDuration}}</div>
                <v-slider
                    v-model="flightDuration"
                    step="1"
                    max="50"
                    @change="getflightDuration()"
                ></v-slider>
            </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content :style="'color:white;background-color:' + theme.primary.base">
          <template v-slot:header>
            <div>
              <v-icon dark>flight</v-icon>
              <label class="ml-1">Airlines</label>
            </div>
          </template>          
            <v-card>
              <FilteringPanelByAirline
                :Airlines="getAirlinesForFiltering()"
                :Loading="LoadingAirlines"
                @SelectedAirlines="a=>{getSelectedAirlines(a)}"
              />
            </v-card>
        </v-expansion-panel-content>

      </v-expansion-panel>
</v-container>
</template>      

<script>
/* eslint-disable */
import theme from '../../theme'
import helper from '../helper'
import FilteringPanelByAirline from './FilteringPanelByAirline'

export default {
    props:[
      'Airlines', 'LoadingAirlines', 'LowestPrice','HighestPrice'
    ],
    components:{
      FilteringPanelByAirline
    },
    watch:{
      LowestPrice:{
        handler:{
          handler:function(val,oldVal){
            if(val!=oldVal) {
              this.refreshPriceRange()
            }
          }
        }
      }
    },
    data(){
        return {
            panel:[true,true,true,true,true,true],
            priceRange:{
                value:[this.LowestPrice,this.HighestPrice],
            },
            outboundDepartureTimeRange:{
                value:[1,this.getTimeSlot(1,30).length]             
            },
            returnDepartureTimeRange:{
                value:[1,this.getTimeSlot(1,30).length]          
            }, 
            flightDuration:50,                         
            theme:this.$vuetify.theme,
            helper:helper,
            filtering:{
                prices:{
                    min:0,max:0
                },
                timeSlots:this.getTimeSlot(1,30),
                flightDurations:{
                    min:0,max:0
                },
            },     
            selectedAirlines:[],    
            directFlightChecked:true,
            connectingFlightChecked:true,
            emitters:{
              SelectedAirlines:'SelectedAirlines',
              RouteIndicator:'RouteIndicator',
              PriceRange:'PriceRange',
              OutboundDepartureTimeRange:'OutboundDepartureTimeRange',
              ReturnDepartureTimeRange:'ReturnDepartureTimeRange',
              FlightDuration:'FlightDuration'
            },            
        }
    },
    methods:{
      refreshPriceRange(){
        this.priceRange = {value:[this.LowestPrice,this.HighestPrice]};
      },
      getTimeSlot(hStep, mStep){
          var maxH = 23;
          var maxM = 59;
          var slots = [];
          for (let i=0;i<=maxH;i += hStep){
              for (let j=0;j<=maxM;j+=mStep){
                  let h = i<10? "0"+i:i;
                  let m = j<10? "0"+ j:j;
                  slots.push (h + ":" + m);
              }
          }
          slots.push("23:59");
          return slots;
      },
      getAirlinesForFiltering(){
        if (this.Airlines==null) return;
        this.Airlines.forEach(element => {
          element.selected = true;
        });
        return this.Airlines;
      },
      getSelectedAirlines(selAirlines){
        this.selectedAirlines = selAirlines;
        this.$emit(this.emitters.SelectedAirlines,this.selectedAirlines);
      },
      getRouteIndicator(){
          var rslt = (this.directFlightChecked? '1':'0') + (this.connectingFlightChecked? '1':'0');
          this.$emit(this.emitters.RouteIndicator, rslt);
      },
      getPriceRange(){
        return this.$emit(this.emitters.PriceRange,this.priceRange.value);
      },
      getOutboundDepartureTimeRange(){
        return this.$emit(this.emitters.OutboundDepartureTimeRange,this.outboundDepartureTimeRange);
      },
      // getReturnDepartureTimeRange(){
      //   return this.$emit(this.emitters.ReturnDepartureTimeRange,this.returnDepartureTimeRange);
      // },
      getflightDuration(){
        return this.$emit(this.emitters.FlightDuration,this.flightDuration*60);
      }
    }
}
</script>

<style>
.slider-card{
    padding-left:15px;
    padding-right:15px;
    padding-top:5px;
}
.slider-card div span{
    font-weight: bold;
}
</style>
